<app-modal-dialog (backdropClick)="onDefer()">
  <div header class="install-modal-header">
    <div class="app-icon" aria-hidden="true">
      <img src="icons/icon-96x96.png" alt="" width="48" height="48" />
    </div>
    <div class="flex-grow">
      <div class="text-lg font-bold" data-testid="install-modal-title">
        {{ 'pwa.install.modal.title' | translate }}
      </div>
      <div class="text-muted text-sm mt-sm">
        {{ 'pwa.install.modal.subtitle' | translate }}
      </div>
    </div>
  </div>

  <div content>
    <!-- iOS instructions -->
    @if (pwaInstall.detectedPlatform() === 'ios') {
    <div class="platform-intro text-muted text-sm" data-testid="install-instructions-ios">
      {{ 'pwa.install.modal.ios.intro' | translate }}
    </div>

    <div class="steps-list">
      <div class="step" data-testid="install-step-1">
        <div class="step-number">1</div>
        <div class="step-body">
          <div class="step-title">{{ 'pwa.install.modal.ios.step1.title' | translate }}</div>
          <div class="step-detail text-muted text-sm">{{ 'pwa.install.modal.ios.step1.detail' | translate }}</div>
        </div>
        <div class="step-icon share-icon" aria-hidden="true">
          <!-- Safari share icon (box with arrow pointing up) -->
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
            <polyline points="16 6 12 2 8 6" />
            <line x1="12" y1="2" x2="12" y2="15" />
          </svg>
        </div>
      </div>

      <div class="step" data-testid="install-step-2">
        <div class="step-number">2</div>
        <div class="step-body">
          <div class="step-title">{{ 'pwa.install.modal.ios.step2.title' | translate }}</div>
          <div class="step-detail text-muted text-sm">{{ 'pwa.install.modal.ios.step2.detail' | translate }}</div>
        </div>
        <div class="step-icon add-icon" aria-hidden="true">
          <!-- Plus-in-square icon -->
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <line x1="12" y1="8" x2="12" y2="16" />
            <line x1="8" y1="12" x2="16" y2="12" />
          </svg>
        </div>
      </div>

      <div class="step" data-testid="install-step-3">
        <div class="step-number">3</div>
        <div class="step-body">
          <div class="step-title">{{ 'pwa.install.modal.ios.step3.title' | translate }}</div>
          <div class="step-detail text-muted text-sm">{{ 'pwa.install.modal.ios.step3.detail' | translate }}</div>
        </div>
      </div>
    </div>

    <div class="warning-note" data-testid="install-bookmark-warning">
      <span class="warning-icon" aria-hidden="true">⚠️</span>
      {{ 'pwa.install.modal.ios.bookmarkWarning' | translate }}
    </div>
    }

    <!-- Android / Chrome instructions -->
    @if (pwaInstall.detectedPlatform() === 'android') {
    <div class="platform-intro text-muted text-sm" data-testid="install-instructions-android">
      {{ 'pwa.install.modal.android.intro' | translate }}
    </div>
    <div class="benefits-list">
      <div class="benefit">✓ {{ 'pwa.install.modal.benefit.offlineAccess' | translate }}</div>
      <div class="benefit">✓ {{ 'pwa.install.modal.benefit.cameraPermissions' | translate }}</div>
      <div class="benefit">✓ {{ 'pwa.install.modal.benefit.fasterLaunch' | translate }}</div>
    </div>
    }

    <!-- Desktop instructions -->
    @if (pwaInstall.detectedPlatform() === 'desktop' || pwaInstall.detectedPlatform() === 'unknown') {
    <div class="platform-intro text-muted text-sm" data-testid="install-instructions-desktop">
      {{ 'pwa.install.modal.desktop.intro' | translate }}
    </div>
    <div class="steps-list">
      <div class="step">
        <div class="step-number">1</div>
        <div class="step-body">
          <div class="step-title">{{ 'pwa.install.modal.desktop.step1.title' | translate }}</div>
          <div class="step-detail text-muted text-sm">{{ 'pwa.install.modal.desktop.step1.detail' | translate }}</div>
        </div>
      </div>
      <div class="step">
        <div class="step-number">2</div>
        <div class="step-body">
          <div class="step-title">{{ 'pwa.install.modal.desktop.step2.title' | translate }}</div>
        </div>
      </div>
    </div>
    }
  </div>

  <div footer class="install-modal-footer">
    <!-- Install button (Android/Desktop - native prompt available) -->
    @if (pwaInstall.detectedPlatform() !== 'ios' && pwaInstall.canInstall()) {
    <app-button data-testid="install-modal-install-btn" [color]="'primary'" (click)="onInstall()">
      {{ 'pwa.install.modal.installBtn' | translate }}
    </app-button>
    }

    <app-button variant="text" data-testid="install-modal-defer-btn" (click)="onDefer()">
      {{ 'pwa.install.modal.deferBtn' | translate }}
    </app-button>
  </div>
</app-modal-dialog>